import React from "react";


export const sectionOne = {
  topTitle: 'What We Provide',
  topSubTitle: 'Looking for a unique and welcoming venue for your next event? Our Masonic Lodge offers a spacious, ' +
    'well-maintained hall available to hire for weddings, receptions, birthdays, meetings, community events, ' +
    'and more. Conveniently located and equipped with kitchen facilities, seating, and ample parking, our venue ' +
    'provides a warm and flexible setting for gatherings of all sizes. Contact us today to check availability ' +
    'and booking details.',
  cardOneTitle: 'Events',
  cardOneDesc: [
    'Our venue features a flexible main hall perfect for any gathering, from private parties and wedding receptions ' +
    'to conferences and training seminars. Booking provides you with exclusive use of the entire hall for your event.',
  ],
  cardTwoTitle: 'Weddings',
  cardTwoDesc: [
      'A ceremony to remember\n' +

      'with seating for up to 120 guests, our Lodge room is fully licensed for weddings and civil ceremonies and is a ' +
      'unique and memorable place to say I do.\n' +
      '\n' +
      'Our on-site caterer will work with your individual requirements to ensure you get the day you’ve always dreamed about.',
  ],
  cardThreeTitle: 'Private Events',
  cardThreeDesc: [
  'Putting your comfort first, Lyora Healthcare Services Ltd specializes in delivering customized domestic care services that perfectly ' +
  'align with your specific needs, preferences, and ...',
    `<ul>
    <li>Anxiety</li>
    <li>Depression</li>
    <li>Bipolar Disorder</li>
    <li>Schizophrenia</li>
    <li>Personality Disorders</li>
    <li>Post-Traumatic Stress Disorder (PTSD)</li>
    <li>Dual Diagnosis</li>
  </ul>`
  ],
  cardFourTitle: 'Specialist Care',
  cardFourDesc: [
    'Our Care Teams undergo extensive training to effectively address a wide spectrum of specialised needs. ' +
    'We possess a deep understanding of the unique symptoms and ...'
  ]
}

export const detailSection = {
  topTitle: 'IT Support & Software Development',
  topSubTitle: 'We provide cost-effective IT support services, we have experience in implementing and supporting\n' +
    '          Microsoft-based IT infrastructures. We build and maintain software by leveraging cutting edge technology.\n' +
    '          In short, we provide an end-to-end support for all your software needs.',
  cardOneTitle: 'IT Support',
  cardOneDesc: [
    "Lyora healthcare services  Ltd provides Domiciliary care for our clients’ needs to be met within their communities.  " +
    "We also provide health and care staff to other agency like local authorities and care homes.\n" +
    "Domiciliary Care",
    "We provide service by supporting clients to maintain their personal hygiene and their daily living tasks within their own environment. " +
    "Lyorahealth Care Ltd will also be supporting adults at risk living in various schemes which include Supported Living, " +
    "Extra Care Housing and permanent placements.",
    "We offer premium care services through our experienced and skilled staffs who are dedicated in meeting the needs of the service users. " +
    "All these services are achieved by promoting a high standard of services delivery, " +
    "which embraces fundamental principles of Good Care practices and is witnessed and evaluated through the practice, " +
    "conduct and control of quality care in the domestic environment.",
    "Lyora Healthcare Services Ltd is registered with Care Quality Commission (CQC)."
  ],
  cardTwoTitle: 'Software Development',
  cardTwoDesc: [
    "We provide competent and qualified \"Agency Staff or locums\" to our clients by attracting, training, and retaining" +
    " qualified and experienced nurses and carers who embody the Lyora Healthcare culture of professional care delivery " +
    "and best outcomes. For the provision of temporary and permanent healthcare workers, we operate as a national and " +
    "international recruitment business and employment agency.",
    "In an industry where great service truly saves lives, regulatory legislation for the recruitment of healthcare " +
    "personnel is a crucial concern. The personnel at Lyora Healthcare Services, as well as our clients, " +
    "understand how important it is for us to follow these rules and regulations.",
    "The international Ethical Recruitment Charter is enshrined in the UK code of Practice for International " +
    "Recruitment of Health and Social Care Professionals in England, and Lyora Healthcare Services follows it. ",
    "Understanding our clients and employees in order to meet their unique needs has always been a key component of " +
    "our success at Lyora Healthcare Services. To achieve ongoing quality improvement in addressing your requirements," +
    " our management encourages input and stays current with reforms in the health and social care sectors."
  ]
}